import { Button, Layout, message, Modal, Spin } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import CustomContext from '../../context/CustomContext';
import styles from './LayoutMarketingComponent.module.scss';
import { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import authService from '../../services/AuthService';
import ga from '../../services/GoogleAnalytics';
import { useIntl } from 'react-intl';

const LayoutMarketingComponent: React.FC<Props> = (props: Props) => {
    const contextType = CustomContext;
    const context = useContext(contextType);

    const intl = useIntl();
    const history = useHistory();

    // calculate screen size
    const screens = useBreakpoint();
    const desktop: boolean = Object.entries(screens)
        .filter((screen) => !!screen[1])
        .some((s) => ['md', 'lg', 'xl', 'xxl'].includes(s[0]));

    const showSignOut = () => {
        Modal.confirm({
            title: intl.formatMessage({ id: 'signOut.title' }),
            onOk: signOut,
        });
    };

    const signOut = async (): Promise<void> => {
        const { updateAuth } = context;
        try {
            ga.createDefaultEvent('sign out', 'sign out - signing out');
            await authService.signOut();
            updateAuth();
            ga.createDefaultEvent('sign out', 'sign out - sign out success');
            history.push('/');
        } catch (error: any) {
            if (error.message) {
                message.error(error.message, 6);
                ga.createDefaultEvent('sign out', `sign out - ${error.message}`);
            } else {
                message.error(intl.formatMessage({ id: 'status.internalError' }), 6);
                ga.createDefaultEvent('sign out', 'sign out - sign out internal error');
            }
        }
    };

    /**
     * Returns the header.
     * @returns the header
     */
    const renderHeader = (): React.ReactNode | undefined => {
        return (
            <header className={styles.head}>
                <div className={styles.row}>
                    <div className={styles.logo}>
                        <a href="https://www.top100sports.com">Top 100 Sports</a>
                    </div>

                    <nav className={styles.mainMenu}>
                        <div className={styles.scroll}>
                            <div className={styles.content}>
                                <div className={styles.menuContainer}>
                                    <ul className={styles.menu}>
                                        <li className={styles.hasChildren}>
                                            <a href="#0">Join T100</a>
                                            <ul className={styles.subMenu}>
                                                <li>
                                                    <a href="https://top100sports.com/cae/">Become an Evaluator</a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/become-an-affiliate/">
                                                        Own a Territory
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={styles.hasChildren}>
                                            <a href="#1">Membership</a>
                                            <ul className={styles.subMenu}>
                                                <li>
                                                    <a href="https://top100sports.com/memberships-for-organizations/">
                                                        Organizations / Clubs
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/excellence/">Individual</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={styles.hasChildren}>
                                            <a href="#2">Services</a>
                                            <ul className={styles.subMenu}>
                                                <li>
                                                    <a href="https://top100sports.com/services/">Performance Testing</a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/services#athlete-report">
                                                        Core4 Athlete Report
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/services#provision-analysis">
                                                        ProVision Analysis
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/services#elite-training">
                                                        Core4 Elite Training
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/services#virtual-training">
                                                        Core4 Virtual Training
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/services#performance-reel">
                                                        Core4 Performance Reel
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/services#college-projection-report">
                                                        Core4 College Projection
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={styles.hasChildren}>
                                            <a href="#3">About Us</a>
                                            <ul className={styles.subMenu}>
                                                <li>
                                                    <a href="https://top100sports.com/about/our-team/">Our Story</a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/about/the-system/">The System</a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/about/core4/">Core4</a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/about/our-members/">
                                                        Our Members
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={styles.hasChildren}>
                                            <a href="#4">Events</a>
                                            <ul className={styles.subMenu}>
                                                <li>
                                                    <a href="https://top100sports.com/events/">Testing Events</a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/leaderboards/">
                                                        Event Leaderboards
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://top100sports.com/top-100-experience-old/">
                                                        TOP 100 Experience
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                        {context.auth && (
                                            <li>
                                                <Button type="link" onClick={showSignOut}>
                                                    Sign Out
                                                </Button>
                                            </li>
                                        )}
                                        {!context.auth && (
                                            <>
                                                <li>
                                                    <a href="https://www.top100sports.com/events/">Register</a>
                                                </li>
                                                <li>
                                                    <Link to="/signin">Log in</Link>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                    <div className={styles.mobileTrigger}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </header>
        );
    };

    /**
     * Returns the footer.
     * @returns the footer
     */
    const renderFooter = (): React.ReactNode | undefined => {
        return (
            <>
                <footer className={styles.pageFooter}>
                    <div className={styles.gradient}></div>
                    <div className={styles.row}>
                        <div className={styles.logo}>
                            <div>
                                <a href="#top" className={styles.footerLogo}>
                                    Top 100 Sports
                                </a>
                                <div className={styles.menuSocial}>
                                    <ul className={styles.menu}>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="http://www.facebook.com/top100sports"
                                            >
                                                Facebook
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://instagram.com/top100sportsusa"
                                            >
                                                Instagram
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" rel="noreferrer" href="http://www.x.com/top100sports">
                                                Twitter
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://www.youtube.com/channel/UCKtIcKMm_XVcQLYk1l-j0qw"
                                            >
                                                YouTube
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <nav>
                                <ul>
                                    <li>Corporate Office</li>
                                    <li>
                                        Lead Testing Facility
                                        <br />
                                        <a
                                            href="https://goo.gl/maps/kVxNULrAzPdBSvfy5"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            6181 Thompson Rd. Syracuse, NY 13206
                                        </a>
                                    </li>
                                    <li>Direct (844) 486-7100</li>
                                </ul>
                            </nav>
                        </div>

                        <div className={styles.menuFooter}>
                            <ul className={styles.menu}>
                                <li className={styles.menuHasChildren}>
                                    <a href="#0">Join T100</a>
                                    <ul className={styles.subMenu}>
                                        <li>
                                            <a href="https://top100sports.com/cae/">Become an Evaluator</a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/become-an-affiliate/">Own a Territory</a>
                                        </li>
                                    </ul>
                                </li>
                                <li className={styles.menuHasChildren}>
                                    <a href="#1">Membership</a>
                                    <ul className={styles.subMenu}>
                                        <li>
                                            <a href="https://top100sports.com/memberships-for-organizations/">
                                                Organizations / Clubs
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/excellence/">Individual</a>
                                        </li>
                                    </ul>
                                </li>
                                <li className={styles.menuHasChildren}>
                                    <a href="#2">Services</a>
                                    <ul className={styles.subMenu}>
                                        <li>
                                            <a href="https://top100sports.com/services/">Performance Testing</a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/services#athlete-report">
                                                Core4 Athlete Report
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/services#provision-analysis">
                                                ProVision Analysis
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/services#elite-training">
                                                Core4 Elite Training
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/services#virtual-training">
                                                Core4 Virtual Training
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/services#performance-reel">
                                                Core4 Performance Reel
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/services#college-projection-report">
                                                Core4 College Projection
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li className={styles.menuHasChildren}>
                                    <a href="#3">About Us</a>
                                    <ul className={styles.subMenu}>
                                        <li>
                                            <a href="https://top100sports.com/about/our-team/">Our Story</a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/about/the-system/">The System</a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/about/core4/">Core4</a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/about/our-members/">Our Members</a>
                                        </li>
                                    </ul>
                                </li>
                                <li className={styles.menuHasChildren}>
                                    <a href="#4">Events</a>
                                    <ul className={styles.subMenu}>
                                        <li>
                                            <a href="https://top100sports.com/events/">Testing Events</a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/leaderboards/">Event Leaderboards</a>
                                        </li>
                                        <li>
                                            <a href="https://top100sports.com/top-100-experience-old/">
                                                TOP 100 Experience
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </footer>
                <footer className={styles.footerLegal}>
                    <div className={styles.row}>
                        <p>© Top 100 Sports. All Rights Reserved.</p>
                        <a href="#0" target="_blank" rel="noreferrer">
                            &nbsp;
                        </a>
                    </div>
                </footer>
            </>
        );
    };

    /**
     * Returns the content page wrapped in the layout template.
     * @param desktop - if the screen size is desktop
     * @returns the content page wrapped in the layout template
     */
    const renderContent = (desktop: boolean): React.ReactNode | undefined => {
        const { content } = props;

        return (
            <div className={styles.pageLayout}>
                <div className={styles.gradient}></div>
                <div className={styles.pageContent}>
                    <div className={styles.line}>
                        <p>TOP 100 SPORTS</p>
                    </div>
                </div>
                <Layout hidden={props.loading}>
                    <Content>{content(desktop)}</Content>
                </Layout>
            </div>
        );
    };

    /**
     * Returns a spinner when the page is initializing.
     * @returns a spinner.
     */
    const renderLoader = (): React.ReactNode | undefined => {
        return (
            <Layout className={styles.main}>
                <Spin size="large" className={styles.spinner}></Spin>
            </Layout>
        );
    };

    return (
        <Layout>
            {renderHeader()}
            {renderContent(desktop)}
            {props.loading && renderLoader()}
            {renderFooter()}
        </Layout>
    );
};
export default LayoutMarketingComponent;

interface Props {
    content: (desktop: boolean) => React.ReactNode | undefined;
    loading?: boolean;
}
